import { schema } from 'normalizr';
import { groupSchema } from './groupSchema';

export const requestSchema = new schema.Entity('request', {
  groupId: groupSchema,
});
